import { render, staticRenderFns } from "./OkexSpotMarketPrice.vue?vue&type=template&id=04e9c8b7&"
import script from "./OkexSpotMarketPrice.vue?vue&type=script&lang=js&"
export * from "./OkexSpotMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports